import { motion } from "framer-motion";
import breakfast1 from "../../../assets/Breakfast/breakfast1.jpg";
import breakfast2 from "../../../assets/Breakfast/breakfast2.jpg";
import breakfast3 from "../../../assets/Breakfast/breakfast3.jpg";
import breakfast4 from "../../../assets/Breakfast/breakfast4.jpg";
import breakfast5 from "../../../assets/Breakfast/breakfast5.jpg";
import breakfast6 from "../../../assets/Breakfast/breakfast6.jpg";
import breakfast7 from "../../../assets/Breakfast/breakfast7.jpg";
import breakfast8 from "../../../assets/Breakfast/breakfast8.jpg";

const breakfastItems = [
  {
    title: "Cream cheese pancakes",
    price: "₹640",
    img: breakfast1,
  },
  {
    title: "Greek avocado toast",
    price: "₹700",
    img: breakfast2,
  },
  {
    title: "Tropical oatmeal",
    price: "₹760",
    img: breakfast3,
  },
  {
    title: "Organic granola parfaits",
    price: "₹490",
    img: breakfast4,
  },
  {
    title: "Spanish omelette",
    price: "₹725",
    img: breakfast5,
  },
  {
    title: "Fruit and cheese plate",
    price: "₹879",
    img: breakfast6,
  },
  {
    title: "Egg salad croissant",
    price: "₹695",
    img: breakfast7,
  },
  {
    title: "Breakfast panini",
    price: "₹950",
    img: breakfast8,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Breakfast = () => {
  return (
    <section className="bg-neutral-100 py-20">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="font-italianno text-primary-800 text-3xl sm:text-4xl">
            Menu
          </span>

          <h2 className="text-primary-700 text-2xl sm:text-3xl xl:text-4xl font-bold tracking-wide mt-1">
            BREAKFAST
          </h2>

         <div className="w-14 h-px bg-primary-400 mx-auto mt-4" />
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 xl:gap-8">
          {breakfastItems.map((item, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="bg-white overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-48 sm:h-52 xl:h-56 2xl:h-60 object-cover"
              />

              <div className="p-4 xl:p-5 2xl:p-6">
                <div className="flex justify-between items-start gap-2">
                  <h4 className="text-primary-700 font-semibold text-sm xl:text-base leading-snug">
                    {item.title}
                  </h4>

                  <span className="text-primary-800 font-semibold text-sm xl:text-base whitespace-nowrap">
                    {item.price}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Breakfast;